import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Stack,
  Box,
} from "@mui/material";
import { NavLink, useLocation } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import { images } from "assets/AssetHelper";
import { useState } from "react";
import { useThemePalette } from "common/hooks/theme_palette";
import { icons } from "assets/AssetHelper";
import { useSelector } from "react-redux";
import Loading from "components/Atoms/SharedComponents/Loading/Loading";
import { useTranslation } from "react-i18next";

const SideNavbar = ({ onClose }) => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const currentUser = useSelector(
    (state) => state.authenticate.currentUserProfile,
  );
  const permissions = useSelector(
    (state) => state.authenticate.currentUserProfile.permissions,
  );
  const load = useSelector((state) => state.authenticate.load);
  const isSuperAdmin = currentUser?.privilege == "super_admin";
  const { primary } = useThemePalette();
  const location = useLocation();
  const path = location.pathname;
  const accountType =
    localStorage?.getItem("account_type") || currentUser?.account_type;
  const isStore =
    localStorage?.getItem("user_type") == "Store" ||
    accountType?.toLowerCase() == "store";
  const [expanded, setExpanded] = useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  let sidebarNavs = [
    {
      title: t("sidebar.dashboard"),
      path: "/dashboard",
      type: "normal",
      icon: icons.dashboard,
    },
    //* DONE EXCEPT ROLES
    isStore && {
      title: t("sidebar.employees") || "Employees",
      path: "/employees",
      type: "normal",
      icon: icons.users,
    },
    ...(isStore
      ? []
      : [
          //* DONE
          {
            title: t("sidebar.system_management"),
            icon: "",
            path: "",
            type: "title",
          },
          {
            title: t("sidebar.users"),
            icon: icons.users,
            path: "",
            type: "",
            list: [
              (isSuperAdmin || permissions?.admin_users?.can_read) && {
                title: t("sidebar.admin_users"),
                path: "/admin-users",
                type: "normal",
              },
              (isSuperAdmin || permissions?.customers?.can_read) && {
                title: t("sidebar.customers"),
                path: "/customers",
                type: "normal",
              },
              (isSuperAdmin || permissions?.drivers?.can_read) && {
                title: t("sidebar.employee_drivers"),
                path: "/employee-drivers",
                type: "normal",
              },
              (isSuperAdmin || permissions?.drivers?.can_read) && {
                title: t("sidebar.freelancer_drivers"),
                path: "/freelancer-drivers",
                type: "normal",
              },
            ],
          },
          (isSuperAdmin || permissions?.stores?.can_read) && {
            title: t("sidebar.vendors"),
            icon: icons.vendorSidebarIcon,
            path: "/vendors",
            type: "normal",
          },
        ]),
    {
      title: t("sidebar.products"),
      path: "",
      type: "",
      icon: icons.products,
      list: [
        (isSuperAdmin || permissions?.products?.can_read) && {
          title: t("sidebar.products"),
          path: "/products",
          type: "normal",
        },
      ],
    },
    //! NOT DONE
    (isSuperAdmin || permissions?.orders?.can_read) && {
      title: t("sidebar.orders"),
      path: "/orders",
      type: "normal",
      icon: icons.orders,
    },
    {
      title: t("sidebar.financial"),
      path: "/financial",
      type: "normal",
      icon: icons.reportData,
    },
    ...(isStore
      ? []
      : [
          (isSuperAdmin || permissions?.orders?.can_read) && {
            title: t("sidebar.cart_logs"),
            path: "/cart-logs",
            type: "normal",
            icon: icons.orders,
          },
          //* DONE
          (isSuperAdmin || permissions?.cart_gift_cards?.can_read) && {
            title: t("sidebar.gift_cards"),
            path: "/gift-cards",
            type: "normal",
            icon: icons.giftcards,
          },
          //* DONE
          isSuperAdmin && {
            title: t("sidebar.promo_codes"),
            path: "/promo-codes",
            type: "normal",
            icon: icons.giftcards,
          },
          isSuperAdmin && {
            title: t("sidebar.merit_gifts"),
            icon: icons.giftcards,
            path: "",
            type: "",
            list: [
              {
                title: t("sidebar.merit_orders"),
                path: "/merit/orders",
                type: "normal",
              },
              {
                title: t("sidebar.merit_api_logs"),
                path: "/merit/api-logs",
                type: "normal",
              },
            ],
          },
          //* DONE
          {
            title: t("sidebar.cities_group"),
            icon: icons.cities,
            path: "",
            type: "",
            list: [
              (isSuperAdmin || permissions?.google_cities?.can_read) && {
                title: t("sidebar.cities"),
                path: "/cities",
                type: "normal",
              },
              (isSuperAdmin || permissions?.zones?.can_read) && {
                title: t("sidebar.zones"),
                path: "/zones",
                type: "normal",
              },
              (isSuperAdmin || permissions?.between_zones_fees?.can_read) && {
                title: t("sidebar.between_zones_fees"),
                path: "/between-zones-fees",
                type: "normal",
              },
            ],
          },
        ]),
    {
      title: t("sidebar.other_pages"),
      icon: "",
      path: "",
      type: "title",
    },
    {
      title: isStore
        ? t("sidebar.chat_with_admin")
        : t("sidebar.chat_with_stores"),
      type: "normal",
      path: "/messenger",
      icon: icons.chat,
    },

    // { title: "Country", path: "/country", type: "normal" },
    // { title: "Vendors", path: "/vendors", type: "normal" },
    ...(isStore
      ? []
      : [
          //* DONE
          (isSuperAdmin || permissions?.system_configurations?.can_read) && {
            title: t("sidebar.system_configuration"),
            path: "/system-configurations",
            type: "normal",
            icon: icons.gear,
          },
        ]),
    {
      title: t("sidebar.event_planning"),
      type: "normal",
      path: "/event-planning",
      icon: icons.occassions,
    },
    //* DONE
    {
      title: t("sidebar.predefined_lookups"),
      icon: icons.reportData,
      path: "",
      type: "",
      list: [
        (isSuperAdmin || permissions?.featured_banners?.can_read) && {
          title: t("sidebar.featured_ads"),
          path: "/featured-ads",
          type: "normal",
        },
        (isSuperAdmin || permissions?.tags?.can_read) && {
          title: t("sidebar.tags"),
          path: "/tags",
          type: "normal",
        },
        (isSuperAdmin || permissions?.option_types?.can_read) && {
          title: t("sidebar.products_option_types"),
          path: "/products-option-types",
          type: "normal",
        },
        (isSuperAdmin || permissions?.order_complaints?.can_read) && {
          title: t("sidebar.complaints_reasons_customer"),
          path: "/customer-complaint-reasons",
          type: "normal",
        },
        (isSuperAdmin || permissions?.route_complaints?.can_read) && {
          title: t("sidebar.complaints_reasons_driver"),
          path: "/driver-complaint-reasons",
          type: "normal",
        },
        (isSuperAdmin || isStore || permissions?.option_values?.can_read) && {
          title: t("sidebar.products_option_values"),
          path: "/products-option-values",
          type: "normal",
        },
        (isSuperAdmin || permissions?.order_declination_reasons?.can_read) && {
          title: t("sidebar.order_declination_reasons"),
          path: "/order-declination-reasons",
          type: "normal",
        },

        (isSuperAdmin || permissions?.categories?.can_read) && {
          title: t("sidebar.categories"),
          path: "/categories",
          type: "normal",
        },
        (isSuperAdmin || permissions?.delivery_times?.can_read) && {
          title: t("sidebar.delivery_times"),
          path: "/delivery-times",
          type: "normal",
        },
        (isSuperAdmin || permissions?.delivery_times?.can_read) && {
          title: t("sidebar.delivery_schedule"),
          path: "/delivery-schedule",
          type: "normal",
        },
        // (isSuperAdmin || permissions?.services?.can_read) &&
        {
          title: t("sidebar.services"),
          path: "/lookups/services",
          type: "normal",
        },
        // (isSuperAdmin || permissions?.themes?.can_read) &&
        {
          title: t("sidebar.themes"),
          path: "/lookups/themes",
          type: "normal",
        },
      ],
    },
    //*DONE
    ...(isStore
      ? []
      : [
          {
            title: t("sidebar.wrappers"),
            icon: icons.wrappers,
            path: "",
            type: "",
            list: [
              (isSuperAdmin || permissions?.wraps?.can_read) && {
                title: t("sidebar.wraps"),
                path: "/wraps",
                type: "normal",
              },
              (isSuperAdmin || permissions?.shapes?.can_read) && {
                title: t("sidebar.shapes"),
                path: "/shapes",
                type: "normal",
              },
              (isSuperAdmin || permissions?.colors?.can_read) && {
                title: t("sidebar.colors"),
                path: "/colors",
                type: "normal",
              },
              (isSuperAdmin || permissions?.wrap_variants?.can_read) && {
                title: t("sidebar.wrap_variants"),
                path: "/wrap-variants",
                type: "normal",
              },
              (isSuperAdmin || permissions?.ribbon_colors?.can_read) && {
                title: t("sidebar.ribbon_colors"),
                path: "/ribbon-colors",
                type: "normal",
              },
              (isSuperAdmin || permissions?.wrap_extras?.can_read) && {
                title: t("sidebar.wraps_extras"),
                path: "/wraps-extras",
                type: "normal",
              },
              (isSuperAdmin || permissions?.suggested_wrappers?.can_read) && {
                title: t("sidebar.suggested_wrappers"),
                path: "/suggested-wrappers",
                type: "normal",
              },
            ].filter((elem) => elem),
          },
          //*DONE
          {
            title: t("sidebar.occasions_group"),
            icon: icons.occassions,
            path: "",
            type: "",
            list: [
              (isSuperAdmin || permissions?.occasions?.can_read) && {
                title: t("sidebar.occasions"),
                path: "/occasions",
                type: "normal",
              },
              (isSuperAdmin || permissions?.occasion_types?.can_read) && {
                title: t("sidebar.occasions_types"),
                path: "/occasions-types",
                type: "normal",
              },
            ],
          },
          {
            title: t("sidebar.complaints_group"),
            icon: icons.complaintsIcon,
            path: "",
            type: "",
            list: [
              (isSuperAdmin || permissions?.order_complaints?.can_read) && {
                title: t("sidebar.customer_complaints"),
                path: "/customer-Complaints",
                type: "normal",
              },
              (isSuperAdmin || permissions?.route_complaints?.can_read) && {
                title: t("sidebar.driver_complaints"),
                path: "/driver-Complaints",
                type: "normal",
              },
            ],
          },
          (isSuperAdmin || permissions?.notifications?.can_read) && {
            title: t("sidebar.notifications"),
            path: "/push-notifications",
            type: "normal",
            icon: icons.document,
          },
        ]),
  ];

  const accountTypeVal =
    localStorage?.getItem("account_type") || currentUser?.account_type;
  if (accountTypeVal?.toLowerCase() === "employee") {
    sidebarNavs = [
      {
        title: t("sidebar.orders"),
        path: "/orders",
        type: "normal",
        icon: icons.orders,
      },
      {
        title: t("sidebar.chat_with_admin") || "Chat with admin",
        type: "normal",
        path: "/messenger",
        icon: icons.chat,
      },
    ];
  }

  sidebarNavs = sidebarNavs
    .map((elem) => {
      if (elem && elem?.type !== "normal") {
        let newList = elem?.list?.filter((el) => el);
        if (newList?.length !== 0) {
          return {
            ...elem,
            list: newList,
          };
        }
        return false;
      } else {
        return elem;
      }
    })
    .filter((elem) => elem);

  return (
    <Stack
      width="100%"
      height="100vh"
      direction="column"
      sx={{ backgroundColor: "#ffffff", overflowY: "scroll" }}
    >
      <Stack
        // width="fit-content"
        width="100%"
        // minHeight="100vh"
        direction="column"
        sx={{
          // backgroundColor: "#1A1A1A",
          backgroundColor: "#ffffff",
          // height: "100%",
          // overflowY: "scroll",
          // position: "fixed",
          left: 0,
        }}
      >
        {/* -------------------- LOGO -------------------- */}
        <Stack
          direction="row"
          alignItems="center"
          sx={{ borderBottom: "1px solid #404040", px: 3, pt: 2, pb: 5 }}
        >
          <Box
            component="img"
            src={images.Logo2}
            loading="lazy"
            width="150px"
            alt=""
          />
        </Stack>
        {/* -------------------- NAVS -------------------- */}
        <Loading
          isLoading={load?.type == "get user" && load?.loading}
          sx={{ bgcolor: "#ffffff !important" }}
        >
          <Stack direction="column" spacing={2} py={1}>
            {sidebarNavs?.map((data, index) => {
              return data?.type === "title" ? (
                <Typography fontWeight={"500"} fontSize={"14px"} px={1}>
                  {data?.title}
                </Typography>
              ) : data?.type === "normal" ? (
                <Stack key={index}>
                  <Stack
                    direction="row"
                    mx={0.5}
                    px={2.5}
                    sx={{
                      bgcolor: path === data.path ? primary : "",
                      height: "50px",
                      borderRadius: "12px",
                      // border:'1px solid red'
                    }}
                    onClick={() => {
                      setExpanded(false);
                      onClose?.();
                    }}
                    gap={0.5}
                  >
                    <img
                      src={data?.icon}
                      alt=""
                      width="24px"
                      style={{
                        filter: path === data.path ? "none" : "invert(1)",
                      }}
                    />
                    <NavLink
                      to={data?.path}
                      style={{
                        fontSize: "16px",
                        textDecoration: "none",
                        color: path === data.path ? "white" : "#333333",
                        marginInlineStart: "5px",
                        // border: "1px solid blue",
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {data?.title}
                    </NavLink>
                  </Stack>
                </Stack>
              ) : (
                <Accordion
                  key={index}
                  sx={{
                    width: "100%",
                    border: "none !important",
                    boxShadow: "none",
                    background: "transparent",
                    padding: "0",
                    "&::before": {
                      display: "none",
                    },
                  }}
                  className="nav-accordion"
                  expanded={expanded === `panel${index}`}
                  onChange={handleChange(`panel${index}`)}
                >
                  <AccordionSummary
                    expandIcon={
                      <ArrowForwardIosIcon
                        sx={{ transform: "rotate(90deg)", color: primary }}
                        fontSize="small"
                      />
                    }
                    aria-controls={`panel${index}a-content`}
                    id={`panel${index}a-header`}
                    sx={{ padding: "0", paddingX: "15px" }}
                  >
                    <Stack gap={0.5} direction="row" alignItems="center">
                      <img
                        src={data?.icon}
                        alt=""
                        width="24px"
                        style={{ marginLeft: "10px", filter: "invert(1)" }}
                      />
                      <NavLink
                        to={data?.path ? data?.path : null}
                        style={{
                          fontSize: "16px",
                          fontWeight: "400",
                          textDecoration: "none",
                          color: "#333333",
                          marginInlineStart: "5px",
                        }}
                      >
                        {data?.title}
                      </NavLink>
                    </Stack>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      background: "#F0F3FF",
                      height: "100%",
                      padding: "0",
                      // width:  "80%",
                      mx: "0",
                      backgroundColor: "transparent",
                    }}
                  >
                    {data?.list?.map((val, idx) => {
                      return (
                        <Typography
                          // padding="15px"
                          // paddingX="25px"
                          key={idx}
                          mx={1}
                          sx={{
                            display: "flex",
                            borderRadius: "4px",
                            overflow: "hidden",
                          }}
                        >
                          <NavLink
                            to={val?.path}
                            onClick={() => onClose?.()}
                            style={{
                              fontSize: "16px",
                              fontWeight: "400",
                              textDecoration: "none",
                              color: path === val?.path ? "white" : "#333333",
                              padding: "10px 24px",
                              width: "100%",
                              backgroundColor: path === val?.path && primary,
                              borderRadius: 12,
                            }}
                          >
                            <Stack
                              flexDirection={"row"}
                              gap={1}
                              alignItems={"center"}
                            >
                              <Typography
                                component="span"
                                sx={{
                                  color:
                                    path === val?.path ? "white" : "#727272",
                                  mr: "5px",
                                  fontSize: "12px",
                                  textAlign: "start",
                                }}
                              >
                                <ArrowForwardIosIcon
                                  sx={{
                                    color:
                                      path === val?.path ? "white" : primary,
                                    transform: isRtl
                                      ? "rotate(180deg)"
                                      : "none",
                                  }}
                                  fontSize="inherit"
                                />
                              </Typography>
                              <Typography sx={{ fontSize: 16 }}>
                                {val?.title}
                              </Typography>
                            </Stack>
                          </NavLink>
                        </Typography>
                      );
                    })}
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </Stack>
        </Loading>
      </Stack>
    </Stack>
  );
};

export default SideNavbar;
